<template>
  <div>
    <div class="display-flex w-100 justify-content-between">
      <h2 style="margin-bottom: 0">Uzytkownicy</h2>
      <v-btn color="#555474" class="mt-0 mb-0 mr-0 ml-3" @click="addUser = true" dark>
        <v-icon size="15px" class="icon-btn">fas fa-plus</v-icon>&nbsp;Dodaj użytkownika
      </v-btn>
    </div>
    <div class="mt-4 content-wrapper p-3">
      <v-data-table
        :headers="getHeaders"
        :items="getUsersList"
        :pagination.sync="paginationData"
        sort-icon="fa-arrow-down" class="elevation-1 main-table"
      >
        <template slot="items" slot-scope="props">
          <td class="white-space-nowrap">{{ props.item.name }} {{props.item.surname}}</td>
          <td>{{ props.item.email }}</td>
          <td>{{ props.item.type | userType }}</td>
          <td>{{ moment(props.item.created_at).format('YYYY-MM-DD') }}</td>
          <td>
            <div class="w-100 display-flex justify-content-center">
              <v-btn small color="default" @click="generatePassword(props.item.id)">Generuj hasło</v-btn>
              <v-btn small color="#555474" @click="editData = props.item; editUser = true;" dark>Edytuj</v-btn>
              <v-btn small color="default" @click="deleteUser = true; idToDelete = props.item.id"
                     style="margin-right: 0">Usuń
              </v-btn>
            </div>
          </td>
        </template>
      </v-data-table>
    </div>
    <createUser
      :open="addUser"
      @close="addUser = false"
      @refresh="fetchUsers(); addUser = false"
    ></createUser>
    <EditUser
      :open="editUser"
      :formData="Object.assign({}, editData)"
      @refresh="fetchUsers(); editUser = false"
      @close="editUser = false"
    ></EditUser>
    <DeleteModal
      :open="deleteUser"
      deleteText="Czy na pewno chcesz usunąć użytkownika?"
      @close="deleteUser = false"
      @accept="removeUser(idToDelete); deleteUser = false"
    ></DeleteModal>
    <InfoModal
      :open="openGeneratePassword"
      :header-message="'Hasło zostało wygenerowane'"
      :description="`Hasło to : <strong>${generatedPassword}</strong>`"
      deleteText="Czy na pewno chcesz usunąć użytkownika?"
      @close="openGeneratePassword = false"
    ></InfoModal>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import CreateUser from '../components/Users/CreateUser.vue';
  import EditUser from '../components/Users/EditUser.vue';
  import DeleteModal from '../components/Globals/ModalDelete.vue';
  import InfoModal from '../components/Globals/InfoModal.vue';

  export default {
    name: 'Users',
    components: {
      CreateUser,
      EditUser,
      DeleteModal,
      InfoModal,
    },
    data() {
      return {
        addUser: false,
        editUser: false,
        deleteUser: false,
        loading: true,
        openGeneratePassword: false,
        idToDelete: Number,
        editData: {},
        generatedPassword: null,
        paginationData: {
          descending: false,
          page: 1,
          rowsPerPage: 10,
        },
      };
    },
    beforeMount() {
      this.fetchUsers()
        .then(() => {
          this.loading = false;
        });
    },
    computed: {
      ...mapGetters('UserStore', ['getUsersList', 'getHeaders']),
    },
    methods: {
      ...mapActions('UserStore', ['fetchUsers', 'removeUser', 'getPassword']),
      generatePassword(id) {
        this.getPassword(id)
          .then((response) => {
            this.generatedPassword = response;
            this.openGeneratePassword = true;
          });
      },
    },
    filters: {
      userType(type) {
        switch (type) {
          case 'A':
            return 'Administrator';
          default:
            return 'Użytkownik';
        }
      },
    },
  };
</script>

<style scoped>

</style>
